import { StateCreator } from "zustand";
import { FilterSliceType } from "./filters.type";
import { addToResetFnsSet } from "../store";

const sliceInitialState = {
  roleFilter: "",
  roleQuery: "",
  // =====
  searchQuery: "",
  usersQueryLimit: 10,
  usersCurrentOffset: 0,
  userDebouncedSearchQuery: "",
  // ===
  incidentSearchParam: "",
  incidentDateRange: "",

  // ===
  userFacilityFilter: "",
  userFacilityQuery: "",
};

const createFilterSlice: StateCreator<FilterSliceType> = (set) => {
  const reset = () => set(sliceInitialState);
  addToResetFnsSet(reset);
  return {
    ...sliceInitialState,
    setRoleFilter: (roleFilter: any) =>
      set(() => {
        return { roleFilter };
      }),

    setIncidentSearchParam: (incidentSearchParam: string) =>
      set(() => {
        return { incidentSearchParam };
      }),
    setIncidentDateRange: (incidentDateRange: string) =>
      set(() => {
        return { incidentDateRange };
      }),
    setUsersQueryLimit: (usersQueryLimit: number) =>
      set(() => {
        return { usersQueryLimit };
      }),
    setUsersCurrentOffset: (usersCurrentOffset: number) =>
      set(() => {
        return { usersCurrentOffset };
      }),
    setUserDebouncedSearchQuery: (userDebouncedSearchQuery: string) =>
      set(() => {
        return { userDebouncedSearchQuery };
      }),
    setRoleQuery: (roleQuery: string) =>
      set(() => {
        return { roleQuery };
      }),
    setSearchQuery: (searchQuery: string) =>
      set(() => {
        return { searchQuery };
      }),
    setUserFacilityFilter: (userFacilityFilter: string) =>
      set(() => {
        return {
          userFacilityFilter,
        };
      }),
    setUserFacilityQuery: (userFacilityQuery: string) =>
      set(() => {
        return {
          userFacilityQuery,
        };
      }),
  };
};

export default createFilterSlice;
